export default "__VITE_PUBLIC_ASSET__067a0778__"